import React from 'react';

const StaffAssociation = () => {
  return (
    <div>
      StaffAssociation
      StaffAssociation
    </div>
  );
}

export default StaffAssociation;
